import { render, staticRenderFns } from "./ModalSolicitacaoCancelamentoBase.vue?vue&type=template&id=db3e4ad0&scoped=true"
import script from "./ModalSolicitacaoCancelamentoBase.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCancelamentoBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3e4ad0",
  null
  
)

export default component.exports